



















export default {
  data () {
    return {
      title: this.$route.query.title || '未知错误',
      msg: this.$route.query.msg || '未知错误信息',
      redirect: this.$route.query.redirect || '/h5',
    }
  },
}
